module.exports = __webpack_public_path__ + "img/newsearch.d4698c40.svg";